import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL

export const supabase = createClient(supabaseUrl, process.env.REACT_APP_SUPABASE_ANON_KEY)
